import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogPage from "../pages/blog/page";
import PostPage from "../pages/post/page";
import CategoryPage from "../pages/category/page";
import AdminPage from "../pages/admin/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import PrivacyPage from "../pages/privacy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/post/:slug",
    element: <PostPage />,
  },
  {
    path: "/categoria/:cat",
    element: <CategoryPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/sobre",
    element: <AboutPage />,
  },
  {
    path: "/contato",
    element: <ContactPage />,
  },
  {
    path: "/privacidade",
    element: <PrivacyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;